<template>
  <section id="pinContainer">
    <!-- LANDING PAGE -->
    <div id="intro" class="panel landing" v-if="$store.state.currentLocation >= 0">
      <div id="intro-parallax" class="panel__parallax panel__parallax--intro" style=""></div>
      <img src="@/assets/img/_branding/ccsa-logo-fr.svg" width="400px" alt="ccsa logo" class="landing__logo">
      <h1 class="landing__h1">Connaissances sur l’usage de substances{{'\xa0'}}: </h1>
      <h2 class="landing__h2">comprendre les faits scientifiques derrière le trouble lié à l’usage de substances</h2>
      <button
        class="btn-nav btn-nav--normal"
        :loc="0.5"
        @click="$store.dispatch('showNext', { n: 0.5, el: '#sb-1-00' })"
      >
        Commencer
      </button>
      <img src="@/assets/img/_ui/down-chevron.svg" width="40px" alt="" class="landing__arrow mt-4">
    </div>

    <!-- 1-00 -->
    <div id="sb-1-00" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 0.5">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p id="sb-1-00-p1" class="text-center">Certaines des choses que l’on pense et que l’on dit à propos des personnes qui consomment des substances ou qui ont un trouble lié à l’usage de substances sont préjudiciables et fausses.   </p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="1"
          link="sb-1-01"
        >
          Go on
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-01 -->
    <div id="sb-1-01" class="panel panel--wipe full-height" v-if="$store.state.currentLocation >= 1">
      <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div>
      <content-block id="animate2" class="content-block--full-height">
        <p id="sb-1-01-p1"><em>«{{'\xa0'}}Les drogués et les alcooliques <strong>n’ont qu’à s’en prendre à eux-mêmes</strong>.{{'\xa0'}}»</em></p>
        <!-- <p id="sb-1-01-p2"><em>“Addiction is a social problem, <strong>not a healthcare issue</strong>.”</em></p>
        <p id="sb-1-01-p3"><em>“Drug users are a <strong>threat</strong> to my safety.”</em></p> -->
        <p id="sb-1-01-p2"><em>«{{'\xa0'}}Pourquoi les toxicomanes <strong>ne cherchent-ils pas de l’aide</strong>?{{'\xa0'}}»</em></p>
        <p id="sb-1-01-p3"><em>«{{'\xa0'}}Je ne suis pas dépendant, moi, alors <strong>pourquoi le sont-ils, eux</strong>?{{'\xa0'}}» </em></p>
        <p id="sb-1-01-p4"><em>«{{'\xa0'}}Je ne sais pas si on peut redevenir <strong>normal</strong> après avoir vécu une dépendance.{{'\xa0'}}»</em></p>
        <p id="sb-1-01-p5"><em>«{{'\xa0'}}La dépendance aux opioïdes, ça n’arrive qu’à <strong>un certain type de personnes</strong>.{{'\xa0'}}» </em></p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="2"
          link="sb-1-02"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-02 -->
    <div id="sb-1-02" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 2">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p id="sb-1-02-p1">Quand <strong>avez-vous parlé</strong> d’une personne qui consomme ou a une dépendance pour la dernière fois? </p>
        <p id="sb-1-02-p2">Vous rappelez-vous ce que vous avez dit? </p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="3"
          link="sb-1-03"
        >
          Go on
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-03 -->
    <div id="sb-1-03" class="panel bg-light-green" v-if="$store.state.currentLocation >= 3">
      <content-block id="sb-1-03-panel-01" class="content-block--full-height text-center">
        <p>Le Canada est en pleine crise de santé publique </p>
        <p><strong class="strong-rockwell">Depuis 2015, les intoxications aux opioïdes ont causé <span id="sb-1-03-p1" class="text-purple">plus de décès au Canada </span> que les accidents de la route.</strong></p>
        <div class="divider-line divider-line--green"></div>
        <img src="@/assets/img/2-03.png" alt="" id="sb-1-03-img-01" class="content-block__img img-fluid">
        <p><strong class="strong-rockwell super-big"><span id="sb-1-03-p2" class="text-purple">1 Canadien sur 5  </span></strong></p>
        <p>de plus de 14 ans souffrira d’un trouble lié à l’usage de substances au cours de sa vie.</p>
        <div class="divider-line divider-line--green"></div>
        <p><strong class="strong-rockwell">Le nombre de vies perdues prématurément ou mises à mal par la maladie mentale et le trouble lié à l’usage de substances est  </strong> <br><strong class="text-purple strong-rockwell super-big"><span style="color:#823C8B;">1,5 fois supérieur </span></strong><br> <strong class="strong-rockwell">à celui de tous les cancers combinés, en Ontario.</strong></p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="4"
          link="sb-1-04b"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-05 -->
    <!-- <div id="sb-1-05" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 5">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p id="sb-1-05-p1">Do you think that <strong>substance use problems</strong> are a type of <strong>illness</strong>?</p>
        <p id="sb-1-05-p2">Why or why not?</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="6"
          link="sb-1-06"
        >
          Keep going
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 2-04 -->
    <!-- <div id="sb-1-04" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 4">
      <content-block class="">
        <p  class="strong-rockwell" id="sb-1-04-p1"><strong class="strong-rockwell-2 text-green">To address the crisis, </strong> <strong class="strong-rockwell-2 text-purple">research is ongoing </strong><strong class="strong-rockwell-2 text-green">to uncover information about substance use and why people react to substances differently.</strong></p>
        <p><strong class="strong-rockwell text-green" id="sb-1-04-p2">We now know that substance use covers a broad range of behaviours.</strong></p>
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" id="sb-1-04-img-01" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <ul>
              <li>From those who use substances occasionally and <strong class="strong-rockwell text-purple">do not experience harms</strong> in the short term…</li>
              <li>To those who <strong class="strong-rockwell text-purple">compulsively seek and use substances</strong> and are unable to make healthy choices, despite the negative consequences of the substance use.</li>
            </ul>
          </div>
          </div>
            <button-sequenced
              class="btn-nav--blue"
              :loc="4.5"
              link="sb-1-04b"
            >
              Continue
            </button-sequenced>
      </content-block>
    </div> -->

    <!-- 2-05 -->
    <div id="sb-1-04b" class="panel bg-light-green panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 4">
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-04b-image">
          </div>
          <div class="col">
          <p id="sb-1-04b-p1">L’<strong class="text-green">usage de substances,</strong> c’est la consommation d’une substance psychoactive, qu’elle soit licite ou illicite <br />(p. ex. l’alcool, les opioïdes, la méthamphétamine et le cannabis).</p>
          <p id="sb-1-04b-p2">Certaines personnes font un usage occasionnel, alors que d’autres le font plus régulièrement.</p>
          <p>Pour certaines personnes, l’usage régulier peut provoquer une altération du cerveau qui, elle, cause un problème de santé appelé  <strong class="text-green">trouble lié à l’usage de substances</strong>.</p>
          </div>
          </div>
        <button-sequenced
          class="btn-nav--white"
          :loc="5"
          link="sb-1-05"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-05 -->
    <div id="sb-1-05" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 5">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Saviez-vous que «{{'\xa0'}}<strong>trouble lié à l’usage de substances</strong>{{'\xa0'}}» est le terme médical reconnu pour désigner ce problème de santé?</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="8"
          link="sb-1-08"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-06a -->
    <!-- <div id="sb-1-06a" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 6">
      <content-block class="">
        <p class="text-green jumbo-text">Experiencing Stigma (CCSA)</p>
        <p>Liz, Volunteer, Community Addictions Peer Support Association</p>
        <div class="">
          <video src="@/assets/video/2-06a.mp4" poster="@/assets/img/_poster/2-06a.png" @ended="replayVideo($event)" controls class="img-fluid"></video>
        </div>
        <div class="accordion-group accordion-group--green" id="sb-1-06a-a">
          <accordion-icon headerText="Transcript">
            <p>With things like cancer you know if you’ve got stage one, they don’t say go back and come back when you got stage 4, come back when you’re really bad, right, and then we’re gonna help you. But with addiction, I didn’t think I was bad enough to need professional help, even though I kept getting worse. </p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="7"
          link="sb-1-07"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-07 -->
    <!-- <div id="sb-1-07" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 7">
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-07-image">
          </div>
          <div class="col">
          <p>Science is also uncovering the mechanisms at work in the brain when it is repeatedly exposed to drugs and alcohol.</p>
          <p>Recent neuroscience research shows that when the brain is <strong class="strong-rockwell text-green">regularly exposed to a substance</strong>, it is affected in ways that make it difficult to resist taking the drug. Regular exposure also affects decision-making abilities.</p>
          </div>
          </div>
            <button-sequenced
              class="btn-nav--blue"
              :loc="8"
              link="sb-1-08"
            >
              Continue
            </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-8 -->
    <div id="sb-1-08" class="panel bg-light-green panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 8">
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-08-image">
          </div>
          <div class="col">
          <p id="sb-1-08-p1">Le circuit de la récompense dans notre cerveau est activé par des activités essentielles pour la survie, comme manger, se reproduire et avoir un comportement social. </p>
          <p id="sb-1-08-p2">Ces récompenses déclenchent la libération d’une molécule, la <strong class="text-green">dopamine</strong>, qui fait ressentir du plaisir et pousse à répéter l’expérience. </p>
          <p id="sb-1-08-p3">La drogue et l’alcool <strong class="text-green">inondent le cerveau de dopamine </strong> en stimulant <strong class="text-green">intensément</strong> le circuit de la récompense, produisant un état de bien-être extrême.</p>
          </div>
          </div>
        <button-sequenced
          class="btn-nav--white"
          :loc="9"
          link="sb-1-09"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-09 -->
    <div id="sb-1-09" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 9">
      <content-block class="">
        <p><strong class="strong-rockwell-2 text-green">Le cerveau réagit en augmentant sa tolérance à cette substance; il en faut donc plus pour atteindre l’état de bien-être.</strong></p>
        <!-- <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-09-image">
          </div>
          <div class="col">
            <p>The brain also responds by <strong class="strong-rockwell text-purple">decreasing the amount of dopamine</strong> available, making people feel depressed when they’re not using the substance.</p>
          </div>
        </div> -->
        <button-sequenced
          class="btn-nav--blue"
          :loc="10"
          link="sb-1-10"
        >
          Continue
        </button-sequenced>
      </content-block>
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <!-- <content-block class="">
        <p class="text-green jumbo-text">Experiencing Stigma (CCSA)</p> -->
        <!-- <p>Debbie Curtis, NL </p> -->
        <!-- <div class=""> -->
          <!-- <iframe width="auto" height="100%" src="https://www.youtube.com/embed/0Hc8mjFFpwQ?rel=0&start=24&end=86" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <!-- <video src="@/assets/video/1-10a.mp4" poster="@/assets/img/_poster/1-10a.png" @ended="replayVideo($event)" controls class="img-fluid">
            <track label="English" kind="subtitles" srclang="en" :src="`${publicPath}cc/ccsa-10a2bcfcf21.en.vtt`" default>
          </video>
        </div>
        <div class="accordion-group accordion-group--orange">
          <accordion-icon headerText="Transcript">
            <p>Stigma was a challenge for me in that at a time when I should have been crying out and reaching out for help over a decade ago to beat addiction to get help with the alcoholism I was going through, as I continued to spiral downward, I didn’t. I was running an organization, I was well known in the community, and how embarrassing that I would come forward that I’m suffering, and I needed to go away and get some help.</p>
            <p>A World Health Organization study across 14 countries ranked illicit substance use disorder as the most stigmatized condition. Alcohol use disorder is ranked fourth.</p>
            <p>The stigma I had about addiction prevented me from getting into treatment sooner. I didn’t think I had gone down low enough. I thought I was functional, and If you’re functional, you’re not really bad enough, warranting the need for treatment.</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="11"
          link="sb-1-11"
        >
          Continue
        </button-sequenced>
      </content-block> -->
    </div>

    <!-- 1-10 -->
    <div id="sb-1-10" class="panel bg-light-green panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 10">
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-10-image">
          </div>
          <div class="col">
          <p>Lorsqu’une personne a un trouble lié à l’usage de substances, le circuit de la récompense du cerveau (les voies neuronales) est <strong class="text-green">modifié</strong> de façon à ce que le cerveau ne puisse penser qu’à cette expérience de bien-être extrême, jusqu’à supplanter les besoins de base. </p>
          <p>Même si la personne <strong class="text-green">veut cesser de consommer</strong>, la partie du cerveau qui <strong class="text-green">prend les décisions</strong> et  <strong class="text-green">contrôle les impulsions est affaiblie</strong>.</p>
          <p>Ce sont ces modifications à la structure et aux circuits du cerveau, résultant d’une exposition répétée aux substances, qui expliquent la  <strong class="text-green">répétition des comportements</strong>, la <strong class="text-green">récurrence de l’usage </strong> et la  <strong class="text-green">sensation de sevrage</strong>.</p>
          </div>
          </div>
        <button-sequenced
          class="btn-nav--white"
          :loc="11"
          link="sb-1-11"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>
    <!-- <div id="sb-1-11" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 11"> -->
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <!-- <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <p>Unfortunately, <strong class="text-green">almost half of Canadians</strong> in recovery from a substance use disorder <strong class="text-green">experience stigma</strong>.</p>
            <p>In fact, international studies by the World Health Organization show that people with alcohol and drug use disorders are among some of the <strong class="text-green">most stigmatized of all health conditions</strong>.</p>
          </div>
        </div> -->
        <!-- <img src="@/assets/img/1-12-bubble.svg" alt="One study found that 50% of respondents said they would not want someone with a drug addiction history as their neighbour." id="sb-1-11-bubble" class="content-block__img img-fluid"> -->
        <!-- <button-sequenced
          class="btn-nav--blue"
          :loc="13"
          link="sb-1-13"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-11 -->
    <div id="sb-1-11" class="panel full-height" v-if="$store.state.currentLocation >= 11">
      <content-block class="">
        <p class="text-green jumbo-text">Effets des traumatismes sur le cerveau et stigmatisation des dépendances et de l’usage de substances </p>
        <p>Cette vidéo, produite par l’Université Carleton, l’ACEPA et le CCDUS, explique comment se développe le trouble lié à l’usage de substances et ce que nous pouvons faire pour réduire la stigmatisation l’entourant. </p>
        <div class="">
          <!-- <iframe width="auto" height="100%" src="https://www.youtube.com/embed/bQrNSXE1OMU?rel=0&start=34&end=57" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <!-- poster="@/assets/img/_poster/1-08a.png" -->
          <video
            src="@/assets/video/2-11.mp4"
            poster="@/assets/img/_poster/2-11.png"
            @ended="replayVideo($event)"
            controls class="img-fluid"
          >
            <track label="Francais" kind="subtitles" srclang="fr" :src="`${publicPath}cc/2-11fr-ca.vtt`" default>
          </video>
        </div>
        <div class="accordion-group accordion-group--green">
          <accordion-icon headerText="Transcription">
            <p> Quand j’étais petite, je ne me sentais pas en sécurité à la maison, et on s’en prenait beaucoup à moi à l’école. J’avais 14 ans quand j’ai bu de l’alcool pour la première fois. J’aimais comment je me sentais alors – j’avais toujours voulu me sentir comme ça – comme tout le monde. </p>
            <p> Je pensais que j’arrivais à gérer ma vie grâce à l’alcool. Mais je m’isolais de plus en plus. Avec le temps, j’ai commencé à mentir à mes proches, à cacher de l’alcool et à avoir des secrets. Tout ça pour pouvoir boire, sans me faire juger.</p>
            <p> Je n’ai jamais voulu en venir au point où les gens diraient : </p>
            <ul>
              <li>«{{'\xa0'}}Elle gâche sa vie.{{'\xa0'}}»</li>
              <li>«{{'\xa0'}}Regarde cette ivrogne.{{'\xa0'}}»</li>
              <li>«{{'\xa0'}}Pourquoi elle choisit l’alcool, et non sa famille? Je ne comprends pas.{{'\xa0'}}»</li>
              <li>«{{'\xa0'}}Pourquoi elle boit tant? Ça va la tuer.{{'\xa0'}}»</li>
              <li>«{{'\xa0'}}Bonne à rien.{{'\xa0'}}» </li>
            </ul>
            <p>J’ai commencé à penser que c’était ma faute et que l’alcool était plus important. Comment en suis-je arrivée là? Ai-je vraiment choisi la dépendance? J’ai choisi de prendre un verre, comme plusieurs de mes amis, mais je n’ai pas choisi la dépendance. Je me suis rendu compte que je devais être bien dans ma peau, pour moi. Puis, j’ai voulu comprendre ce qui me différenciait des autres... et pourquoi j’étais devenue dépendante de l’alcool, mais pas eux. </p>
            <p>Une partie de notre cerveau s’occupe de notre bien-être, et si elle se dérègle, cela peut avoir des effets dévastateurs. La partie du cerveau directement derrière le front est appelée cortex préfrontal et assure le «{{'\xa0'}}contrôle exécutif{{'\xa0'}}» du cerveau. L’une de ses grandes fonctions est de réguler différents circuits cérébraux, comme ceux de la peur et de la récompense. Par exemple, lors d’un événement traumatisant, le cortex préfrontal active le circuit de la peur et envoie des signaux à une autre structure cérébrale, l’amygdale, le «{{'\xa0'}}centre de la peur{{'\xa0'}}». À son tour, l’amygdale active une autre structure, appelée l’hippocampe, qui stocke de l’information sur les gens, les endroits ou les choses qui présentent une menace. Quand nous les rencontrons par la suite, l’hippocampe nous rappelle de les éviter. Par contre, le circuit de la récompense semble moins actif après un traumatisme. Certaines personnes pourraient donc consommer des substances comme l’alcool ou l’héroïne pour se sentir mieux.</p>
            <p>Qu’est-ce que ça signifie? Pourquoi mon cerveau voyait-il l’alcool comme une bonne stratégie d’adaptation? Les scientifiques sont maintenant d’avis qu’à la suite d’un traumatisme, le «{{'\xa0'}}circuit de la récompense{{'\xa0'}}» est hypoactif, et le «{{'\xa0'}}circuit de la peur{{'\xa0'}}» est hyperactif. C’est donc dire que le cortex préfrontal n’arrive pas à trouver un équilibre entre les deux circuits. Alors mon cerveau considérait l’alcool comme une solution, parce qu’il augmentait la récompense et diminuait la peur que je vivais. À ce moment, l’important, ce n’était pas d’être heureuse, mais bien de survivre. </p>
            <p>Sachant que des changements réels étaient survenus dans mon cerveau, j’ai appris à me traiter avec gentillesse et j’ai compris que je n’avais pas choisi la dépendance. Cela dit, je ne veux pas redevenir celle que j’étais quand j’ai commencé à boire. Quand je pensais que c’était moi le problème, il n’y avait pas grand-chose à faire. Quand j’ai compris qu’il y avait un problème avec mon esprit, j’ai compris que le changement était possible. J’ai appris que si j’arrivais à changer mon esprit, je pourrais changer ma vie et me tracer un nouveau chemin.</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="12"
          link="sb-1-12"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-12 -->
    <div id="sb-1-12" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 12">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>On reproche souvent aux personnes ayant un trouble lié à l’usage de substances de manquer de volonté. </p>
        <p>Voyez-vous comment cela est <strong>contredit</strong> par les explications sur la neurobiologie du cerveau?    </p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="13"
          link="sb-1-13"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-13 -->
    <div id="sb-1-13" class="panel panel__parallax--1-14 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 13">
      <!-- <div id="" class="panel__parallax panel__parallax--1-14" style=""></div> -->
       <content-block class="">
        <p><strong class="strong-rockwell-2 text-green">Personne ne choisit de devenir dépendant à la drogue ou à l’alcool</strong>.</p>
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-13-image">
          </div>
          <div class="col">
            <!-- <p>The paths that lead people to substance use disorder are different and complex based on many factors, acting alone or together. </p> -->
            <p>De <strong class="strong-rockwell text-purple">multiples facteurs de risque</strong> influent sur la probabilité de développer un trouble lié à l’usage de substances.</p>
            <p>De nombreuses personnes consomment des substances comme la marijuana ou l’alcool dans un contexte de vie sociale. </p>
            <p>Les personnes à risque ne finiront pas toutes par avoir un problème de consommation; certains facteurs de protection font baisser le risque.</p>
          </div>
          </div>
            <button-sequenced
              class="btn-nav--blue"
              :loc="14"
              link="sb-1-14"
            >
              Continue
            </button-sequenced>
      </content-block>
    </div>
      <!-- 1-14 - 16 -->
    <div id="sb-1-14" class="panel bg-light-green full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 14">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block>
        <p class="jumbo-text text-purple">Voici quelques facteurs de risque.</p>
        <div class="accordion-group accordion-group--purple" >
          <accordion-icon headerText="Génétique">
            <p>Le risque d’avoir un trouble lié à l’usage de substances est déterminé environ à moitié par la génétique, mais une prédisposition génétique ne signifie pas toujours qu’une personne développera ce trouble.</p>
          </accordion-icon>
          <accordion-icon headerText="Situation personnelle ">
            <p>Les gens se tournent souvent vers la drogue ou l’alcool pour composer avec des émotions ou des circonstances difficiles. </p>
            <p>Une personne peut dépendre de certaines drogues pour se calmer lorsqu’elle est stressée, ou consommer de l’alcool ou du cannabis pour réduire ses inhibitions et faciliter ses interactions sociales. L’usage régulier peut entraîner une dépendance.</p>
          </accordion-icon>
          <accordion-icon headerText="Environnement">
            <p>Certains facteurs environnementaux peuvent influer sur l’apparition d’un trouble lié à l’usage de substances.</p>
            <p>Voici quelques facteurs environnementaux.</p>
            <ul>
              <li>
                <p style="color:#298328;"><strong>Vie familiale</strong></p>
                <p>Les enfants qui grandissent dans un milieu marqué par le conflit ou dont les proches consomment régulièrement des substances risquent davantage d’avoir un trouble lié à l’usage de substances en grandissant. Les adultes pourraient être influencés par leur partenaire qui consomme de la drogue. Avoir une vie familiale pleine de conflits et être stressé est un facteur de risque environnemental du trouble lié à l’usage de substances.</p>
              </li>
              <li>
                <p style="color:#298328;"><strong>École </strong></p>
                <p>C’est souvent à l’école qu’on entre en contact pour la première fois avec l’alcool ou la drogue. On commence parfois à consommer régulièrement avec des amis qui font de même.</p>
              </li>
              <li>
                <p style="color:#298328;"><strong>Travail</strong></p>
                <p>Parmi les facteurs qui contribuent à l’usage de substances, il y a le travail par quarts, un niveau de stress élevé, le travail de première ligne avec une exposition fréquente à des événements traumatisants ou dans un milieu où l’usage de substances est courant et accepté.</p>
              </li>
            </ul>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="17"
          link="sb-1-17"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-17 -->
    <div id="sb-1-17" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 17">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Vous connaissez probablement quelqu’un qui a eu des difficultés avec l’usage de substances quand d’autres n’en ont pas.</p>
        <p>Quand vous pensez à ces personnes, quels sont les facteurs qui ont pu les mener là où elles sont? Voyez-vous la façon dont elles vivent leur vie <strong>différemment</strong>?</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="18"
          link="sb-1-18"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-18 -->
    <div id="sb-1-18" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 18">
      <div id="" class="" style=""></div>
      <content-block class="">
        <p id="sb-1-18-p1">Outre les facteurs de risque génétiques, situationnels et environnementaux, il est essentiel de reconnaître le <strong class="strong-rockwell text-purple">rôle du traumatisme</strong> chez les personnes ayant un trouble lié à l’usage de substances.</p>
        <p id="sb-1-18-p2">Vivre un traumatisme est une réponse émotionnelle à un événement profondément stressant ou perturbant. Les traumatismes <strong class="strong-rockwell text-purple">peuvent accroître le risque </strong> de développer un trouble lié à l’usage de substances. Une personne pourrait consommer pour composer avec ses souvenirs traumatiques ou les refouler.</p>
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-18-image">
          </div>
          <div class="col" id="">
            <p id="sb-1-18-p3"><strong class="strong-rockwell text-purple">Le traumatisme influence le cerveau </strong> dans les fonctions liées à{{'\xa0'}}:</p>
            <ul>
              <li>L’intégration des souvenirs </li>
              <li>L’intégration de souvenirs émotionnels (les souvenirs d’expériences qui ont suscité une réaction émotionnelle)</li>
              <li>La planification et la résolution de problèmes </li>
              <li>La fuite, la lutte et l'inhibition</li>
            </ul>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="19"
          link="sb-1-19"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-19 -->
    <div id="sb-1-19" class="panel bg-light-green panel__parallax--1-14 d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 19">
      <div id="" class="" style=""></div>
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-19-image">
          </div>
          <div class="col">
            <p>Les traumatismes qui surviennent pendant la petite enfance, lorsque le cerveau se développe encore et est vulnérable, ont de grandes répercussions. Les <strong class="text-purple">expériences néfastes durant l’enfance (ENE)</strong> peuvent perturber les circuits cérébraux liés au traitement de la peur et les signaux de récompense, et augmenter le risque ultérieur de maladies physiques ou mentales, comme le trouble lié à l’usage de substances. </p>
            <p>Les ENE prennent plusieurs formes, comme les mauvais traitements, la négligence et le dysfonctionnement familial. Certains facteurs de protection, comme un lien solide entre parent et enfant, peuvent atténuer les risques.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="20"
          link="sb-1-20"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

      <!-- 1-19a -->
    <!-- <div id="sb-1-19a" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 19.5">
      <content-block>
        <img src="@/assets/img/2-19-quote.svg" alt="The first question is not, “Why the addiction?” but “Why the pain?”" class="content-block__img img-fluid" id="sb-1-19a-image">
        <p class="text-center">- Gabor Maté, author, public speaker and former medical columnist for the Globe and Mail</p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="19.7"
          link="sb-1-19b"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-19b -->
    <!-- <div id="sb-1-19b" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 19.7">
      <content-block class="">
        <p class="text-green jumbo-text">Brain Story in Action: Addressing Stigma (CCSA)</p>
        <p>Debbie Curtis, Co-Chair, NL Brain Story Network, Mental Health and Addictions Consultant </p>
        <div class="">
          <video src="@/assets/video/2-19b.mp4" poster="@/assets/img/_poster/2-19b.png" @ended="replayVideo($event)" controls class="img-fluid" id="sb-1-19b-video">
          </video>
        </div>
        <div class="accordion-group accordion-group--green">
          <accordion-icon headerText="Transcript">
            <p>Learning about the brain story can help people have that compassion for people, that this is like a disease, like any other chronic disease, that it’s not people’s fault. That this is not a choice they’ve made.</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="20"
          link="sb-1-20"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-20 -->
    <div id="sb-1-20" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 20">
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-20-image">
          </div>
          <div class="col">
            <p>Le trouble lié à l’usage de substances est une <strong class="strong-rockwell text-green">affection complexe</strong>, dont il n’est pas toujours facile de comprendre les causes fondamentales.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="21"
          link="sb-1-21"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-21 -->
    <div id="sb-1-21" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 21">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Vous rappelez-vous une interaction avec une personne ayant un trouble lié à l’usage de substances que vous regrettez?</p>
        <p>Si vous pouviez recommencer, <strong>que changeriez-vous</strong>?</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="22"
          link="sb-1-22"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-22 -->
    <div id="sb-1-22" class="panel bg-light-green panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 22">
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-22-image">
          </div>
          <div class="col">
            <p>À mesure que vous découvrez les aspects neuroscientifiques du trouble lié à l’usage de substances, vous pourriez en arriver à penser qu’il est impossible de s’en sortir.</p>
            <p>Il s’agit après tout d’une affection complexe aux facteurs de risque et de protection multiples, qui se manifeste de nombreuses façons.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="23"
          link="sb-1-23"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-23 -->
    <div id="sb-1-23" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 23">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Étant donné la complexité du trouble lié à l’usage de substances, est-il possible selon vous de <strong>trouver le bien-être</strong>?</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="24"
          link="sb-1-24"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-24 -->
    <div id="sb-1-24" class="panel panel__parallax--1-14 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 24">
      <content-block>
        <div class="row">
          <div id="sb-1-24-panel-01" class="bg-light-green p-4">
            <!-- <p class="jumbo-text text-purple"><strong>Truth</strong></p> -->
            <p>En réalité, le trouble lié à l’usage de substances <strong class="text-purple">se traite</strong>, et il est <strong class="text-purple">possible de trouver le bien-être</strong>.</p>
            <p>Malgré les difficiles défis associés à ce trouble et les liens souvent profondément ancrés dans le passé, <strong class="text-purple">de nombreuses personnes</strong> mènent une vie saine.</p>
            <p>Pour trouver le bien-être, il faut <strong class="text-purple">bâtir de nouvelles voies neuronales et acquérir des capacités d’adaptation</strong> pour mettre fin aux fortes envies de consommer suscitées par les déclencheurs.</p>
            <p>Il est difficile de reconstruire sa vie, même lorsque l’on cesse de consommer.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="25"
          link="sb-1-25"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-25 -->
    <div id="sb-1-25" class="panel panel__parallax--1-14 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 25">
      <content-block>
        <div class="row">
          <div id="sb-1-25-panel-02" class="bg-light-green p-4">
            <!-- <p class="jumbo-text text-purple"><strong>Fact</strong></p> -->
            <p>Le fait est que le <strong class="text-purple">risque de récurrence</strong> du trouble lié à l’usage substances <strong class="text-purple">est élevé. Il faut habituellement plusieurs tentatives </strong> pour trouver un <strong class="text-purple">rétablissement</strong> à long terme.  </p>
            <p><strong class="text-purple">La vie est pleine de surprises et parfois éprouvante</strong>. Il peut être difficile de composer avec la douleur émotionnelle, les traumatismes et les changements. </p>
            <p>Le cheminement vers le bien-être est souvent <strong class="text-purple">tortueux</strong> et pourrait être ponctué de récurrences.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="25.5"
          link="sb-1-25b"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-25b -->
    <div id="sb-1-25b" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 25.5">
      <content-block class="">
        <p class="text-green jumbo-text">Ma voie vers le bien-être</p>
        <p>ACEPA Canada</p>
        <div class="">
          <video
            src="@/assets/video/2-25b.mp4"
            poster="@/assets/img/_poster/2-25b.jpg"
            @ended="replayVideo($event)"
            controls controlsList="nodownload"
            class="img-fluid" id="sb-1-19b-video"
          >
            <track label="Francais" kind="subtitles" srclang="fr" :src="`${publicPath}cc/2-25b.fr.vtt`" default>
          </video>
        </div>
        <div class="accordion-group accordion-group--green">
          <accordion-icon headerText="Transcription">
            <p>Je pense être sur la voie vers le bien-être. Puis, certains jours, sans que je sache comment, je me retrouve à nouveau dans la mauvaise direction alors que j’ai tout fait pour rediriger mon cerveau afin qu’il réagisse différemment au stress dans ma vie.</p>
            <p>Avoir un trouble lié à l’usage de substances n’a jamais été un choix conscient de ma part. On me dit que c’est peut-être le résultat d'un traumatisme ou de la génétique ou quelque chose d'autre.</p>
            <p>Quant à moi, je sais que je lutte pour arrêter de consommer des substances malgré les conséquences négatives. Bien sûr que je veux avoir une meilleure vie, mais j’ignore combien de temps cela me prendra pour y arriver ou à quoi cela ressemblera exactement.</p>
            <p>Je découvre seulement certains des défis que je dois relever. Je sais que certaines personnes changent plus rapidement que d'autres et que le bien-être a l’air différent pour chaque personne.</p>
            <p>J’ai l’impression que certaines personnes atteignent leur bien-être et y restent, même si d'autres font des allers-retours au gré des aléas de leur vie. Alors que moi, je n’arrête pas de me heurter à des obstacles en chemin.</p>
            <p>Parfois je pars complètement dans la mauvaise direction et je dois faire demi-tour. Bien des gens ont cessé de m'aider lorsque cela m'arrive. Si seulement ils pouvaient se rappeler que la dépendance est une maladie qui affecte mon cerveau et ma prise de décision. Si seulement moi aussi, je pouvais m'en souvenir, j’avancerais de manière plus constante. </p>
            <p>C'est l’un de mes défis. Je veux me rendre au bien-être autant que les autres veulent que j’y arrive.</p>
            <p>Je sais que la vie y sera moins imprévisible pour moi, et pour eux, mais me dire que je dois y arriver à une heure précise ou en empruntant un certain itinéraire ne m'aide pas.</p>
            <p>M’imposer une heure d'arrivée ne signifie pas que je peux la respecter. Cela ne fait que donner aux gens un faux sentiment de contrôle. Je me demande pourquoi la compassion dont ils font preuve à l’égard d’une personne qui est malade se fait en fonction de certains critères.</p>
            <p>Moi, je ne dirais jamais à une personne souffrante qu’elle doit se rétablir à une heure donnée; je ne peux qu’espérer qu’elle ira mieux et j'essaye de lui donner l’aide dont elle a besoin à ce moment. </p>
            <p>J'ai vu des personnes s’arrêter pour aider des automobilistes qui ont crevé ou qui sont tombés en panne sèche. Ils sont restés jusqu’à ce que les secours arrivent pour s’assurer que la personne était en sécurité et pouvait reprendre la route. Personne ne juge ou n’est déçu quand on roule sur un clou ou qu’on manque d'essence. J'aimerais que les gens fassent preuve de la même compréhension quand je rencontre des obstacles qui me ralentissent ou quand je m’épuise en chemin.  </p>
            <p>J'aimerais que les gens comprennent que trouver ma voie vers le bien-être me prendra bien plus de temps si je marche seule.</p>
            <p>Pour en savoir plus sur les voies vers le bien-être, s’il vous plaît, rendez-vous sur <a href="https://www.capsa.ca/resources" target="_blank">www.capsa.ca/resources</a></p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="26"
          link="sb-1-26"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-26 -->
    <div id="sb-1-26" class=" panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 26">
      <content-block class="content-block--full-height">
        <p>Si vous apprenez qu’une personne rencontre des obstacles dans son rétablissement, <strong class="strong-rockwell text-purple">soutenez-la </strong> plutôt que de la juger. Il faut du temps pour bâtir de nouvelles voies neuronales et changer les comportements.</p>
        <p>La méthode éprouvée, c’est de traiter l’obstacle comme un recul temporaire, d’en tirer des leçons et de  <strong class="strong-rockwell text-purple">ne pas le voir comme un échec</strong>. </p>
        <p>Il vaut mieux se concentrer sur les progrès réalisés lors des tentatives précédentes, comme des changements positifs au mode de vie ou la réduction d’autres comportements à risque élevé.</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="27"
          link="sb-1-27"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-27 -->
    <div id="sb-1-27" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 27">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Pensez à un geste que vous pourriez faire pour aider une personne à demander de l’aide et à recevoir l’aide dont elle a besoin.</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="28"
          link="sb-1-28"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>
    <!-- 1-28 -->

    <div id="sb-1-28" class="panel panel__parallax--chevron-bg full-height" v-if="$store.state.currentLocation >= 28">
      <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div>
      <content-block class="">
<p>Une bonne façon d’apporter votre soutien est de confronter et de démonter les affirmations inutiles et stigmatisantes trop souvent émises par les autres.
 </p>
        <p>Voici quelques suggestions de <strong class="strong-rockwell text-purple">réponses basées sur des données probantes</strong> à utiliser lorsque vous entendez des opinions et des points de vue communs, mais néfastes. </p>
        <div id="sb-1-28-a">
        <div class="accordion-group accordion-group--green mb-0" >
          <accordion-icon headerText="Si vous entendez : ">
            <p>«{{'\xa0'}}On choisit d’être dépendant à la drogue ou à l’alcool.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--light-purple mt-0 mb-4">
          <accordion-icon headerText="Répondez :">
            <p>De <strong>nombreux facteurs de risque</strong> influent sur le risque de développer un trouble lié à l’usage de substances. </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--green mb-0 mt-4">
          <accordion-icon headerText="Si vous entendez : ">
            <p>«{{'\xa0'}}Ma vie n’a pas été facile; pourtant je ne suis pas tout le temps gelé ou saoul. Il y a quelque chose qui ne va pas chez eux.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--light-purple mt-0 mb-4">
          <accordion-icon headerText="Répondez : ">
            <p>«{{'\xa0'}}La vie est imprévisible et difficile, et chacun la vit à sa façon. Le trouble lié à l’usage de substances est un problème de santé complexe, et de nombreux facteurs de risque et de protection entrent en jeu.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--green mb-0">
          <accordion-icon headerText="Si vous entendez : ">
            <p>«{{'\xa0'}}Pourquoi ne pas tout simplement demander de l’aide si cela gâche leur vie?{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--light-purple mt-0 mb-4">
          <accordion-icon headerText="Répondez : ">
            <p>«{{'\xa0'}}Les personnes stigmatisées ressentent de la honte et pensent qu’elles ne méritent pas de recevoir de l’aide. Parfois, cette stigmatisation vient du secteur de la santé et des fournisseurs de services eux-mêmes.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <!-- <div class="accordion-group accordion-group--green mb-0">
          <accordion-icon headerText="Si vous entendez{{'\xa0'}}: ">
            <p>“People with substance use disorder are unpredictable and dangerous”</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--light-purple mt-0 mb-4">
          <accordion-icon headerText="Répondez{{'\xa0'}}: ">
            <p>“Substances affect people in different ways. Reacting with fear escalates situations. You can learn some techniques to help ensure a safe outcome.”</p>
          </accordion-icon>
        </div> -->
        <div class="accordion-group accordion-group--green mb-0">
          <accordion-icon headerText="Si vous entendez : ">
            <p>«{{'\xa0'}}L’abstinence est la seule façon de trouver le bien-être.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--light-purple mt-0 mb-4">
          <accordion-icon headerText="Répondez : ">
            <p>«{{'\xa0'}}Certaines personnes choisissent l’abstinence pour atteindre le bien-être, mais nombreux sont les chemins qui mènent vers le bien-être. Le cheminement vers le bien-être est <strong>souvent tortueux</strong>, et les récurrences sont fréquentes.{{'\xa0'}}»</p>
          </accordion-icon>
        </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="29"
          link="sb-1-29"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-29 -->
    <div id="sb-1-29" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 29">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Connaissez-vous d’autres opinions non fondées qu’on entend couramment à propos des personnes ayant un trouble lié à l’usage de substances? </p>
        <p>Forts de <strong>vos nouvelles connaissances</strong>, comment réagirez-vous la prochaine fois que vous entendrez une telle opinion?</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="31"
          link="sb-1-31"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-30 -->
    <!-- <div id="sb-1-30" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 30">
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-30-image">
          </div>
          <div class="col">
            <p>Thank you for taking time to uncover the science on substance use disorders. </p>
            <p>We <strong class="strong-rockwell text-purple">make a difference</strong> when we use words that respect the dignity of all people, focus on the medical nature of substance use disorders and take the proven approach to support people as they work towards wellness.  </p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="31"
          link="sb-1-31"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-31 -->
      <content-block id="sb-1-31" class="stigma-wrapper" v-if="$store.state.currentLocation >= 31">
        <!-- 1-28-01 -->
        <div id="stigma-01" class="stigma" v-if="$store.state.currentLocation === 31">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}Les drogués et les alcooliques <strong>n’ont qu’à s’en prendre à eux-mêmes</strong>.{{'\xa0'}}»</em></p>
            <!-- <p class="stigma-wrong__text-strike">Using drugs is a <strong>choice</strong>, they just need to stop</p> -->
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text"><strong>Plusieurs facteurs de risque et de protection</strong> entrent en jeu dans l’apparition du trouble lié à l’usage de substances.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="31.1"
            link="sb-1-31"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-02 -->
        <div id="stigma-02" class="stigma" v-if="$store.state.currentLocation === 31.1">
          <div class="stigma__wrong">
              <!-- <div class="stigma__wrong-cross"></div> -->
              <p class="stigma-wrong__text"><em>«{{'\xa0'}}Pourquoi les toxicomanes ne <strong>cherchent-ils pas de l’aide</strong>?{{'\xa0'}}»</em></p>
            <!-- <div class="position-relative d-inline-block">
              <div class="stigma__wrong-cross"></div>
              <p class="stigma-wrong__text">If they even have a job, they’re probably <strong>untrustworthy employees</strong>.</p>
            </div> -->
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">Plusieurs facteurs empêchent de demander de l’aide, comme des <strong>changements cérébraux</strong> attribuables à l’usage de substances, la honte et la <strong>stigmatisation</strong>.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="31.2"
            link="sb-1-31"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-03 -->
        <div id="stigma-03" class="stigma" v-if="$store.state.currentLocation === 31.2">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}Je ne suis pas dépendant, moi, alors <strong>pourquoi le sont-ils, eux</strong>?{{'\xa0'}}» </em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text"><em>De <strong>nombreux facteurs</strong> propres à chacun – génétique, environnement, vie familiale, école et travail – <strong>font considérablement augmenter le risque de trouble lié à l’usage de substances</strong>.</em> </p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="31.3"
            link="sb-1-31"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-04 -->
        <div id="stigma-04" class="stigma" v-if="$store.state.currentLocation === 31.3">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}Je ne sais pas si on peut redevenir <strong>normal</strong> après avoir vécu une dépendance.{{'\xa0'}}»</em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">Le <strong>cheminement vers le bien-être</strong> est souvent tortueux, mais il est possible pour de nombreuses personnes. </p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="31.4"
            link="sb-1-31"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-05 -->
        <div id="stigma-05" class="stigma" v-if="$store.state.currentLocation >= 31.4">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}La dépendance aux opioïdes, ça n’arrive qu’à <strong>un certain type de personnes</strong>.{{'\xa0'}}»</em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">Il existe de nombreuses voies qui conduisent à l’apparition d’un trouble lié à l’usage de substances. Celui-ci touche des personnes <strong>de tous horizons</strong>, peu importe leur revenu, leur profession, leur âge, leur culture ou le quartier où elles vivent.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="32.5"
            link="sb-1-32"
          >
            Continue
          </button-sequenced>
        </div>
      </content-block>

    <!-- 2-19a -->
    <!-- <div id="sb-1-19a" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 32">
      <content-block>
        <img src="@/assets/img/2-19-quote.svg" alt="The first question is not, “Why the addiction?” but “Why the pain?”" class="content-block__img img-fluid" id="sb-1-19a-image">
        <p class="text-center">- Gabor Maté, author, public speaker and former medical columnist for the Globe and Mail</p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="32.5"
          link="sb-1-32"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-24 -->
    <div id="sb-1-32" class="panel bg-charcoal full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 32.5">
      <content-block class="pt-0">
        <h2 class="jumbo-text text-center">Mon engagement</h2>
        <p>Je m’engage à poser ces trois gestes dès aujourd’hui pour éliminer la stigmatisation.</p>
        <ul>
          <li>J’utiliserai <strong class="text-beige">des termes médicalement exacts</strong> parce que je reconnais que le trouble lié à l’usage de substances est un problème de santé chronique. </li>
          <li>J’appliquerai ce que j’ai appris et je m’<strong class="text-beige">exprimerai</strong> à l’aide de réponses basées sur des données probantes lorsque j’entendrai d’autres personnes répandre de l’information fausse ou néfaste sur le trouble lié à l’usage de substances.</li>
          <li>J’<strong class="text-beige">aiderai les personnes  </strong> qui ont un trouble lié à l’usage de substances si elles vivent une récurrence parce que je reconnais que celle-ci n’est ni un choix ni un échec, et fait partie du problème de santé lui-même. </li>
        </ul>
        <button
          class="btn-nav btn-nav--normal-white"
          @click="openPopup = true"
          v-if="!courseCompleted"
        >
          Je le ferai
        </button>
      </content-block>
    </div>

    <modal-popup v-if="openPopup" @close="openPopup = false, courseCompleted = true">
      <content-block class="">
        <img src="@/assets/img/_branding/ccsa-logo-fr.svg" width="250px" alt="" class="content-block__img img-fluid">
        <p>Merci d’avoir pris le temps de découvrir la science du trouble lié à l’usage de substances.  </p>
        <p>Nous pouvons <strong class=""> changer les choses </strong> en employant des mots qui respectent la dignité de tous et insistent sur l’aspect médical de ce trouble et en adoptant une approche éprouvée pour accompagner ceux qui cherchent à trouver le bien-être.</p>
      </content-block>
    </modal-popup>

    <!-- Progress Bar -->
    <div class="progress-wrapper">
      <progress-bar
        size="large"
        :val="getCourseProgress"
        bar-color="#A761B0"
      ></progress-bar>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import ContentBlock from '@/components/ContentBlock.vue'
import ButtonSequenced from '@/components/ButtonSequenced.vue'
import AccordionIcon from '@/components/AccordionIcon.vue'
import ModalPopup from '@/components/ModalPopup.vue'

import ProgressBar from 'vue-simple-progress'

// GSAP STUFF
import { TimelineMax } from 'gsap'

// jQuery
const $ = require('jquery')
window.$ = $

export default {
  name: 'Home',
  components: {
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    ModalPopup,
    ProgressBar
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      openPopup: false,
      courseCompleted: false
    }
  },
  updated () {
    /**
     * 1-00
     */
    if (this.$store.state.currentLocation === 0.5) {
      const sbTimeline00 = new TimelineMax()
        .from('#sb-1-00>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-00 p', 0.5, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-00 button', 0, { alpha: 0, y: -20 })

      const sbScene00 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-00',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-00', { pushFollowers: true })
        .setTween(sbTimeline00)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene00)
    }

    /**
     * 1-01
     */
    if (this.$store.state.currentLocation === 1) {
      const wipeAnimation = new TimelineMax()
        .staggerFrom('#sb-1-01 p', 2, { alpha: 0, color: '#D40E8C', scale: '1.1' }, 1)
        .from('#sb-1-01 button', 0, { alpha: 0, y: -20 })
      const pinScene = this.$scrollmagic.scene({
        triggerElement: '#sb-1-01',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
      // .setPin('#sb-1-01', { pushFollowers: true })
        .setTween(wipeAnimation)
      // .addIndicators() // add indicators (requires plugin)
      // .addTo(controller)
      this.$scrollmagic.addScene(pinScene)
    }

    /**
     * 1-02
     */
    if (this.$store.state.currentLocation === 2) {
      const sbTimeline02 = new TimelineMax()
        .from('#sb-1-02>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-02 p', 0.5, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-02 button', 0, { alpha: 0, y: -20 })

      const sbScene02 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-02',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-02', { pushFollowers: true })
        .setTween(sbTimeline02)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene02)
    }

    // /**
    //  * 1-03
    //  */
    // if (this.$store.state.currentLocation === 3) {
    //   const sbTimeline03 = new TimelineMax()
    //     .from('#sb-1-03-panel-01', 1, { x: 3000 }, 'first')
    //     .from('#sb-1-03-panel-02', 1, { x: -3000 }, 'first')
    //     .from('#sb-1-03-panel-03', 1, { x: 3000 }, 'first')

    //   const sbScene03 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-03',
    //     triggerHook: '0.5',
    //     duration: 0,
    //     reverse: false
    //   })
    //     // // .setPin('#sb-1-03', { pushFollowers: true })
    //     .setTween(sbTimeline03)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene03)
    // }

    /**
     * 1-03
     */
    if (this.$store.state.currentLocation === 3) {
      const sbTimeline03 = new TimelineMax()
        // .staggerFrom('#sb-1-03 p', 0.5, { alpha: 0 }, 0.25, 'first')
        .from('#sb-1-03-p1', 0.5, { color: '#823C8B' }, 'first')
        // .from('#sb-1-03-img-01', 0.5, { alpha: 0.5 })
        .from('#sb-1-03-p2', 0.5, { fontSize: '2rem' })
        .from('#sb-1-03-p3', 0.5, { color: '#823C8B' })
        .from('#sb-1-03-p4', 0.5, { color: '#823C8B' })
        .staggerFrom('#sb-1-03 li', 1, { alpha: 0 }, 0.25)

      const sbScene03 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-03',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-03', { pushFollowers: true })
        .setTween(sbTimeline03)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene03)
    }

    /**
     * 1-04
     */
    // if (this.$store.state.currentLocation === 4) {
    //   const sbTimeline05 = new TimelineMax()
    //     .from('#sb-1-04>.panel__parallax', 1, { y: '20%' }, 'first')
    //     .staggerFrom('#sb-1-04-p1', 1, { alpha: 0 }, 0.5, 'second')
    //     .staggerFrom('#sb-1-04-p2', 1, { alpha: 0 }, 0.5, 'second')
    //     .staggerFrom('#sb-1-04-img-01', 1, { alpha: 0 }, 0.5, 'third')
    //     .staggerFrom('#sb-1-04 li', 1, { alpha: 0 }, 0.5, 'third')
    //     .staggerFrom('#sb-1-04-p3', 1, { alpha: 0 }, 0.5, 'fourth')
    //     .staggerFrom('#sb-1-04-p4', 1, { alpha: 0 }, 0.5, 'fourth')
    //     .from('#sb-1-04 button', 0, { alpha: 0, y: -20 })

    //   const sbScene05 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-04',
    //     triggerHook: '0.5',
    //     duration: 0,
    //     reverse: false
    //   })
    //     // .setPin('#sb-1-05', { pushFollowers: true })
    //     .setTween(sbTimeline05)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene05)
    // }

    /**
     * 1-05
     */
    if (this.$store.state.currentLocation === 4) {
      const sbTimeline055 = new TimelineMax()
        .from('#sb-1-04b>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-04b p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-04b button', 0, { alpha: 0, y: -20 })

      const sbScene055 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-04b',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-055', { pushFollowers: true })
        .setTween(sbTimeline055)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene055)
    }

    /**
     * 1-05
     */
    if (this.$store.state.currentLocation === 5) {
      const sbTimeline06 = new TimelineMax()
        .from('#sb-1-05>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-05 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-06 strong', 1, { color: '#5D6978' }, 0.5, 'second')
        .from('#sb-1-05 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene06 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-05',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-06', { pushFollowers: false })
        .setTween(sbTimeline06)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene06)
    }

    /**
     * 1-06
     */
    // if (this.$store.state.currentLocation === 6) {
    //   const sbTimeline07 = new TimelineMax()
    //     .from('#sb-1-06a>.panel__parallax', 1, { y: '20%' }, 'first')
    //     .staggerFrom('#sb-1-06a p', 1, { alpha: 0 }, 0.5, 'first')
    //     // .staggerFrom('#sb-1-06a-a', 1, { alpha: 0 }, 0.5, 'second')
    //     .from('#sb-1-06 button', 0, { alpha: 0, y: -20 }, 'third')

    //   const sbScene07 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-06a',
    //     triggerHook: '0.5',
    //     duration: 0,
    //     reverse: false
    //   })
    //     // .setPin('#sb-1-07', { pushFollowers: true })
    //     .setTween(sbTimeline07)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene07)
    // }

    /**
     * 1-07
     */
    // if (this.$store.state.currentLocation === 7) {
    //   const sbTimeline08 = new TimelineMax()
    //     .from('#sb-1-07>.panel__parallax', 1, { y: '20%' }, 'first')
    //     .staggerFrom('#sb-1-07 p', 1, { alpha: 0 }, 0.5, 'first')
    //     .from('#sb-1-07 button', 0, { alpha: 0, y: -20 })

    //   const sbScene08 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-07',
    //     triggerHook: '0.5',
    //     duration: 0,
    //     reverse: false
    //   })
    //     // // .setPin('#sb-1-07', { pushFollowers: true })
    //     .setTween(sbTimeline08)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene08)
    // }

    /**
     * 1-08
     */
    if (this.$store.state.currentLocation === 8) {
      const sbTimeline09 = new TimelineMax()
        .from('#sb-1-08>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-08 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-08 button', 0, { alpha: 0, y: -20 })

      const sbScene09 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-08',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-07', { pushFollowers: true })
        .setTween(sbTimeline09)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene09)
    }

    /**
     * 1-09
     */
    if (this.$store.state.currentLocation === 9) {
      const sbTimeline10 = new TimelineMax()
        .from('#sb-1-09>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-09-image', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-09 p', 1, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-09 button', 0, { alpha: 0, y: -20 }, 'third')

      const sbScene10 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-09',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-10', { pushFollowers: true })
        .setTween(sbTimeline10)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene10)
    }

    /**
     * 1-10
     */
    if (this.$store.state.currentLocation === 10) {
      const sbTimeline11 = new TimelineMax()
        .from('#sb-1-10>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-10 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-10 button', 0, { alpha: 0, y: -20 })

      const sbScene11 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-10',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-07', { pushFollowers: true })
        .setTween(sbTimeline11)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene11)
    }

    /**
     * 1-12
     */
    if (this.$store.state.currentLocation === 12) {
      const sbTimeline07 = new TimelineMax()
        .from('#sb-1-12>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-12 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-12 button', 0, { alpha: 0, y: -20 })

      const sbScene07 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-12',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-07', { pushFollowers: true })
        .setTween(sbTimeline07)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene07)
    }

    /**
     * 1-13
     */
    if (this.$store.state.currentLocation === 13) {
      const sbTimeline13 = new TimelineMax()
        .from('#sb-1-13>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-13 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-13-image', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-13 button', 0, { alpha: 0, y: -20 })

      const sbScene13 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-13',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-13', { pushFollowers: true })
        .setTween(sbTimeline13)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene13)
    }

    /**
     * 1-14
     */
    if (this.$store.state.currentLocation === 14) {
      const sbTimeline14 = new TimelineMax()
        // .from('#sb-1-14>.panel__parallax', 1, { y: '20%' }, 'first')
        .from('#sb-1-14 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-14 .accordion', 1, { alpha: 0, x: -30 }, 0.5, 'second')
        .from('#sb-1-14 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene14 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-14',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-14', { pushFollowers: true })
        .setTween(sbTimeline14)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene14)
    }

    /**
     * 1-17
     */
    if (this.$store.state.currentLocation === 17) {
      const sbTimeline17 = new TimelineMax()
        .from('#sb-1-17>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-17 p', 1, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-17 button', 0, { alpha: 0, y: -20 })

      const sbScene17 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-17',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-07', { pushFollowers: true })
        .setTween(sbTimeline17)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene17)
    }

    /**
     * 1-18
     */
    if (this.$store.state.currentLocation === 18) {
      const sbTimeline18 = new TimelineMax()
        .from('#sb-1-18>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-18-p1', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-18-p2', 1, { alpha: 0 }, 0.5, 'second')
        .staggerFrom('#sb-1-18-image', 1, { alpha: 0 }, 0.5, 'third')
        .staggerFrom('#sb-1-18-p3', 1, { alpha: 0 }, 0.5, 'fourth')
        .staggerFrom('#sb-1-18 li', 1, { alpha: 0 }, 0.5, 'fifth')
        .from('#sb-1-18 button', 0, { alpha: 0, y: -20 })

      const sbScene18 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-18',
        triggerHook: '0.5',
        duration: '0'
      })
        // .setPin('#sb-1-16', { pushFollowers: true })
        .setTween(sbTimeline18)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene18)
    }

    /**
     * 1-19
     */
    if (this.$store.state.currentLocation === 19) {
      const sbTimeline19 = new TimelineMax()
        .from('#sb-1-19>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-19 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-19-image', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-19 button', 0, { alpha: 0, y: -20 })

      const sbScene19 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-19',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-19', { pushFollowers: true })
        .setTween(sbTimeline19)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene19)
    }

    /**
     * 1-19b
     */
    // if (this.$store.state.currentLocation === 19.7) {
    //   const sbTimeline19b = new TimelineMax()
    //     .from('#sb-1-19b>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
    //     .staggerFrom('#sb-1-19b p', 1, { alpha: 0 }, 0.5, 'first')
    //     .staggerFrom('#sb-1-19b-image', 1, { alpha: 0 }, 0.5, 'first')
    //     // .staggerFrom('#sb-1-19b-video', 1, { alpha: 0 }, 0.5, 'first')
    //     // .staggerFrom('#sb-1-17 strong', 1, { color: '#5D6978' }, 0.5, 'second')
    //     .from('#sb-1-19b button', 0, { alpha: 0, y: '20px' }, 'third')

    //   const sbScene19b = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-19b',
    //     triggerHook: '0.5',
    //     duration: 0,
    //     reverse: false
    //   })
    //     // .setPin('#sb-1-17', { pushFollowers: true })
    //     .setTween(sbTimeline19b)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene19b)
    // }

    /**
     * 1-20
     */
    if (this.$store.state.currentLocation === 20) {
      const sbTimeline20 = new TimelineMax()
        .from('#sb-1-20>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        .staggerFrom('#sb-1-20-image', 1, { alpha: 0 }, 0.5, 'second')
        .staggerFrom('#sb-1-20 p', 1, { alpha: 0 }, 0.5, 'second')
        // .staggerFrom('#sb-1-18 strong', 1, { color: '#5D6978' }, 0.5, 'second')
        // .staggerFrom('#sb-1-18 .patterned-list li', 1, { alpha: 0 }, 0.5, 'second')
        // .from('#sb-1-18-panel-01', 1, { x: '-25%', alpha: 0 }, 'third')
        // .from('#sb-1-18-panel-02', 1, { x: '25%', alpha: 0 }, 'third')
        // .staggerFrom('#sb-1-18 .accordion', 1, { alpha: 0, y: 30 }, 0.5, 'first')
        .from('#sb-1-20 button', 0, { alpha: 0, y: '20px' }, 'third')

      const sbScene20 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-18',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-18', { pushFollowers: true })
        .setTween(sbTimeline20)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene20)
    }

    /**
     * 1-21
     */
    if (this.$store.state.currentLocation === 21) {
      const sbTimeline21 = new TimelineMax()
        .from('#sb-1-21>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        .staggerFrom('#sb-1-21 p', 1, { alpha: 0 }, 0.5, 'second')
        .staggerFrom('#sb-1-21 .patterned-list li', 1, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-21 button', 0, { alpha: 0, y: '20px' }, 'third')

      const sbScene21 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-21',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-19', { pushFollowers: true })
        .setTween(sbTimeline21)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene21)
    }

    /**
     * 1-22
     */
    if (this.$store.state.currentLocation === 22) {
      const sbTimeline22 = new TimelineMax()
        .from('#sb-1-22>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-22 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-22-image', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-22 button', 0, { alpha: 0, y: -20 })

      const sbScene22 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-22',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-20', { pushFollowers: true })
        .setTween(sbTimeline22)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene22)
    }

    /**
     * 1-23
     */
    if (this.$store.state.currentLocation === 23) {
      const sbTimeline23 = new TimelineMax()
        .from('#sb-1-23>.panel__parallax', 1, { y: '20%' }, 'first')
        // .from('#sb-1-21 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-23 p', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-23 button', 0, { alpha: 0, y: -20 })
        // .staggerFrom('#sb-1-21 li', 0.3, { alpha: 0 }, 0.2, 'second')

      const sbScene23 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-23',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-21', { pushFollowers: true })
        .setTween(sbTimeline23)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene23)
    }

    /**
     * 1-24
     */
    if (this.$store.state.currentLocation === 24) {
      const sbTimeline24 = new TimelineMax()
        .from('#sb-1-24-panel-01', 1, { x: '-25%', alpha: 0 }, 'third')
        .from('#sb-1-24 button', 0, { alpha: 0, y: '20px' }, 'fourth')

      const sbScene24 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-24',
        triggerHook: '1',
        duration: 0,
        reverse: false
      })
        .setTween(sbTimeline24)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene24)
    }

    /**
     * 1-25
     */
    if (this.$store.state.currentLocation === 25) {
      const sbTimeline25 = new TimelineMax()
        .from('#sb-1-25-panel-02', 1, { x: '25%', alpha: 0 }, 'third')
        .from('#sb-1-25 button', 0, { alpha: 0, y: '20px' }, 'fourth')

      const sbScene25 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '1',
        duration: 0,
        reverse: false
      })
        .setTween(sbTimeline25)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene25)
    }

    /**
     * 1-26
     */
    if (this.$store.state.currentLocation === 26) {
      const sbTimeline26 = new TimelineMax()
        // .from('#sb-1-23 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-26 p', 1, { alpha: 0 }, 0.5, 'second')
        // .staggerFrom('#sb-1-23 li', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-26 button', 0, { alpha: 0, y: '20px' })

      const sbScene26 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-26',
        triggerHook: '1',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-23', { pushFollowers: true })
        .setTween(sbTimeline26)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene26)
    }

    /**
     * 1-27
     */
    if (this.$store.state.currentLocation === 27) {
      const sbTimeline27 = new TimelineMax()
        .from('#sb-1-27>.panel__parallax', 1, { y: '20%' }, 'first')
        // .from('#sb-1-24 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-27 p', 0.5, { alpha: 0 }, 0.5, 'second')
        // .staggerFrom('#sb-1-24 strong', 0.5, { color: '#5D6978' }, 0.2, 'second')
        // .staggerFrom('#sb-1-24 li', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-27 button', 0, { alpha: 0, y: '20px' })

      const sbScene27 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-27',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-24', { pushFollowers: true })
        .setTween(sbTimeline27)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene27)
    }

    //   /**
    //    * 1-28
    //    */
    if (this.$store.state.currentLocation === 28) {
      const sbTimeline28 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        // .from('#sb-1-24 img', 0.5, { x: '-20%', alpha: 0 })
        .from('#sb-1-28 button', 0, { alpha: 0, y: '20px' }, 0.5, 'first')
        .from('#sb-1-28 p', 0.5, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-28-a', 0.5, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-28 .accordion-group', 0.5, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-24 strong', 0.5, { color: '#5D6978' }, 0.2, 'second')
        // .staggerFrom('#sb-1-24 li', 0.3, { alpha: 0 }, 0.2, 'second')

      const sbScene28 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-28',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-24', { pushFollowers: true })
        .setTween(sbTimeline28)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene28)
    }

    /**
     * 1-29
     */
    if (this.$store.state.currentLocation === 29) {
      const sbTimeline29 = new TimelineMax()
        .from('#sb-1-29>.panel__parallax', 1, { y: '20%' }, 'first')
        // .from('#sb-1-26 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-29 p', 0.5, { alpha: 0 }, 0.5, 'second')
        // .staggerFrom('#sb-1-26 li', 0.3, { x: -29, alpha: 0 }, 0.2, 'second')
        // .staggerFrom('#sb-1-26 li', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-29 button', 0, { alpha: 0, y: '20px' }, 'third')

      const sbScene29 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-29',
        triggerHook: '1',
        duration: 0,
        reverse: false
      })
        // // .setPin('#sb-1-26', { pushFollowers: true })
        .setTween(sbTimeline29)
      // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene29)
    }

    /**
     * 1-30
     */
    if (this.$store.state.currentLocation === 30) {
      const sbTimeline30 = new TimelineMax()
        .from('#sb-1-30>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-30 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-30-image', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-30 button', 0, { alpha: 0, y: -20 })

      const sbScene30 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-30',
        triggerHook: '0.5',
        duration: 0,
        reverse: false
      })
        // .setPin('#sb-1-30', { pushFollowers: true })
        .setTween(sbTimeline30)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene30)
    }

    //   /**
    //    * 1-27
    //    */
    //   if (this.$store.state.currentLocation === 27) {
    //   }

    /**
     * 1-31
     */
    if (this.$store.state.currentLocation >= 31) {
      const sbTimeline31 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-01 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-01', 1, { alpha: 0, y: '20%' })
        .set('#stigma-01 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-01 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-01 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-01 button', 0, { alpha: 0, y: '-20%' })

      const sbScene31 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-31',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimeline31)
        // .setClassToggle('#stigma-01 .stigma-wrong__text', 'stigma-wrong__text--strike') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene31)
    }

    // STIGMA 2
    if (this.$store.state.currentLocation >= 28.1) {
      const sbTimelineStigma02 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-02 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-02', 1, { alpha: 0, y: '20%' })
        .set('#stigma-02 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .staggerFrom('#stigma-02 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-02 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-02 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma02 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-31',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma02)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma02)
    }

    // STIGMA 3
    if (this.$store.state.currentLocation >= 28.2) {
      const sbTimelineStigma03 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-03 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-03', 1, { alpha: 0, y: '20%' })
        .set('#stigma-03 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-03 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-03 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-03 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma03 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-31',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma03)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma03)
    }

    // STIGMA 4
    if (this.$store.state.currentLocation >= 28.3) {
      const sbTimelineStigma04 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-04 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-04', 1, { alpha: 0, y: '20%' })
        .set('#stigma-04 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-04 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-04 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-04 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma04 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-31',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma04)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma04)
    }

    // STIGMA 5
    if (this.$store.state.currentLocation >= 28.4) {
      const sbTimelineStigma05 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-05 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-05', 1, { alpha: 0, y: '20%' })
        .set('#stigma-05 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-05 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-05 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-05 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma05 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-31',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma05)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma05)
    }

    // STIGMA 6
    // if (this.$store.state.currentLocation >= 28.5) {
    //   const sbTimelineStigma06 = new TimelineMax()
    //     // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
    //     .set('#stigma-06 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
    //     .from('#stigma-06', 1, { alpha: 0, y: '20%' })
    //     .set('#stigma-06 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
    //     // .from('#stigma-06 .stigma__wrong-cross', 1, { width: '0%' })
    //     .from('#stigma-06 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
    //     .from('#stigma-06 button', 0, { alpha: 0, y: '-20%' })

    //   const sbSceneStigma06 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-31',
    //     triggerHook: '0.5',
    //     duration: 0
    //   })
    //     .setTween(sbTimelineStigma06)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbSceneStigma06)
    // }

    /**
     * 1-19a
     */
    // if (this.$store.state.currentLocation === 32) {
    //   const sbTimeline19a = new TimelineMax()
    //     .from('#sb-1-19a img', 0.5, { x: '-20%', alpha: 0 })
    //     .staggerFrom('#sb-1-19a p', 0.3, { alpha: 0 }, 0.2, 'first')
    //     // .staggerFrom('#sb-1-19a li', 0.3, { alpha: 0 }, 0.2, 'second')

    //   const sbScene19a = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-19a',
    //     triggerHook: '0.5',
    //     reverse: false
    //   })
    //     // .setPin('#sb-1-19a', { pushFollowers: true })
    //     .setTween(sbTimeline19a)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene19a)
    // }

    //   /**
    //    * 1-29
    //    */
    //   if (this.$store.state.currentLocation === 29) {
    //     const sbTimeline29 = new TimelineMax()
    //       .from('#sb-1-29 img', 0.5, { x: '-20%', alpha: 0 })
    //       .staggerFrom('#sb-1-29 p', 0.3, { alpha: 0 }, 0.2, 'first')
    //       // .staggerFrom('#sb-1-29 li', 0.3, { alpha: 0 }, 0.2, 'second')

    //     const sbScene29 = this.$scrollmagic.scene({
    //       triggerElement: '#sb-1-29',
    //       triggerHook: '0.5',
    //       duration: 0,
    //       reverse: false
    //     })
    //       // .setPin('#sb-1-29', { pushFollowers: true })
    //       .setTween(sbTimeline29)
    //       // .addIndicators() // add indicators (requires plugin)
    //     this.$scrollmagic.addScene(sbScene29)
    //   }

    //   /**
    //    * 1-30
    //    */
    //   if (this.$store.state.currentLocation === 30) {
    //   }
  },
  methods: {
    replayVideo (e) {
      e.currentTarget.load()
    }
  },
  computed: {
    // return total quiz progress of (current store quizProgress / total number of questions) * 100
    getCourseProgress () {
      const progress = ((this.$store.state.currentLocation) / this.$store.state.totalPages) * 100
      return progress
    }
  },
  mounted () {
    // Fire init event
    this.$store.dispatch('initCourse')
    /**
     * IE FIX
     */
    if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
      $('body').on('mousewheel', function () {
        // remove default behavior
        event.preventDefault()

        // scroll without smoothing
        var wheelDelta = event.wheelDelta
        var currentScrollPosition = window.pageYOffset
        window.scrollTo(0, currentScrollPosition - wheelDelta)
      })
    }
    /**
     * INTRO
     */
    const intro = this.$scrollmagic.scene({
      triggerElement: '#intro',
      triggerHook: 0,
      duration: '100%'
    })
      .setTween('#intro-parallax', { y: '20%' })
      // .addIndicators()
    this.$scrollmagic.addScene(intro)
  }
}
</script>

<style lang="scss">
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import '../styles/colors';

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
